import {useLayoutEffect} from 'react';
import {QueryParamsForTaggingEnum} from 'presentation/constants';
import {useQueryParams} from 'presentation/pages/private/hooks';
import {RequestAuthorizationStep} from '../constants';

interface UseRequestAuthStepSyncProps {
	currentStep: RequestAuthorizationStep;
}

export function useRequestAuthStepSync({currentStep}: UseRequestAuthStepSyncProps) {
	const {setSearchParams} = useQueryParams();

	useLayoutEffect(() => {
		if (currentStep === RequestAuthorizationStep.PROVIDER_SELECTION) {
			setSearchParams(
				prev => {
					prev.set(QueryParamsForTaggingEnum.REQUEST_AUTH_STEP, '1');
					return prev;
				},
				{replace: true},
			);
		} else if (currentStep === RequestAuthorizationStep.ATTACHMENTS) {
			setSearchParams(
				prev => {
					prev.set(QueryParamsForTaggingEnum.REQUEST_AUTH_STEP, '2');
					return prev;
				},
				{replace: true},
			);
		} else {
			setSearchParams(
				prev => {
					prev.delete(QueryParamsForTaggingEnum.REQUEST_AUTH_STEP);
					return prev;
				},
				{replace: true},
			);
		}
	}, [currentStep, setSearchParams]);
}
